import { createMiddleWare } from './apiMiddleWare';
import { callApi } from './service';

export const middleWare = createMiddleWare(callApi);